import { mode, styleConfig } from "@chakra-ui/theme-tools";
var tooltip = styleConfig({
  baseStyle: function baseStyle(props) {
    return {
      padding: "2",
      bg: mode("gray.700", "gray.300")(props),
      color: mode("whiteAlpha.900", "gray.900")(props),
      borderRadius: "md",
      fontWeight: "medium",
      pointerEvents: "none",
      fontSize: "xs",
      boxShadow: "md",
      maxWidth: "320px"
    };
  },
  transition: {
    container: {
      timeout: 120,
      transition: {
        easing: "ease-in-out",
        duration: "120ms",
        property: "common"
      },
      enter: {
        from: {
          opacity: 0.01,
          transform: "scale(0.9)"
        },
        to: {
          opacity: 1,
          transform: "scale(1)"
        }
      },
      exit: {
        from: {
          opacity: 1,
          transform: "scale(1)"
        },
        to: {
          opacity: 0.01,
          transform: "scale(0.9)"
        }
      }
    }
  }
});
export default tooltip;